import React from 'react'

type MdashProps = {
  /** Optionally add a class */
  customClass?: string
  /** Optional prop to add a test id to the Mdash for QA testing */
  qaTestId?: string
}

export default function Mdash({
  customClass = '',
  qaTestId = 'mdash',
}: MdashProps): React.JSX.Element {
  return (
    <span className={customClass} qa-test-id={qaTestId}>
      &mdash;
    </span>
  )
}
